import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React from 'react'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { galeryAction } from 'src/store/Slices/Administrator/GalerySlice';
import { formatIsoToDateNew, formatIsoToTime } from 'src/components/helpers/formateDate'

const MobileTrainingRecords = ({
    servicesList,
    servicesListLoading,
    page,
    setPage,
    setPageSize,
}) => {

    const dispatch = useDispatch()
    const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',]

    const newDate = new Date()

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Pagination
                    defaultCurrent={page}
                    pageSize={20}
                    showSizeChanger={false}
                    current={page}
                    onChange={(page, pageSize) => {
                        dispatch(passagesAction({ flag: 'get', value:{
                            DateFrom: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 00:00:00`,
                            DateTo: `${weekDays[newDate.getDay()]}, ${newDate.getDate()} ${months[newDate.getMonth()]} ${newDate.getFullYear()} 23:59:59` }
                        }))
                        setPage(page)
                        setPageSize(pageSize)
                    }}
                    total={servicesList?.data?.value?.totalCount}
                    page={page}
                />
                {servicesList?.data?.value?.rows.map(element => {
                    return (
                        <Card
                            loading={servicesListLoading}
                            title={`№: ${element.id}`}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>ФИО:</div>
                                    <div>Телефон:</div>
                                    <div>Наименование:</div>
                                    <div>Тренер:</div>
                                    <div>Зал:</div>
                                    <div>Клуб:</div>
                                    <div>Услуга:</div>
                                    <div>Дата:</div>
                                    <div>Время:</div>
                                </div>
                                <div>
                                    <div>{element?.userFio ? <Tooltip title={element?.userFio}>{element?.userFio.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.userPhone ? <Tooltip title={element?.userPhone}>{element?.userPhone.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.name ? <Tooltip title={element?.name}>{element?.name.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.employName ? <Tooltip title={element?.employName}>{element?.employName.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.className ? <Tooltip title={element?.className}>{element?.className.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.clubName ? <Tooltip title={element?.clubName}>{element?.clubName.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.serviceName ? <Tooltip title={element?.serviceName}>{element?.serviceName.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.date ? <Tooltip title={formatIsoToDateNew(element.date) + ' ' + formatIsoToTime(element.date)}>{formatIsoToDateNew(element.date) + ' ' + formatIsoToTime(element.date)}</Tooltip> : '-'}</div>
                                    <div>{element?.time ? <Tooltip title={element?.time}>{element?.time.slice(0, 15)}</Tooltip> : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
            </div>
        </>
    )
}

export default MobileTrainingRecords